<template>
  <div class="cookies-policy-page">
    <default :title="title" :wrap-content="true">
      <template slot="content">
        <div class="content no-select">
          <template v-for="(html, index) in content">
            <div v-html="html"></div>
            <cookie-description v-if="index===0 && cookies.length > 0" :cookies="cookies"></cookie-description>
          </template>
        </div>
      </template>
    </default>
  </div>
</template>

<script>
import cookies from "@views/public/pages/CookiePolicy/cookies";
import cookies_settings from "@views/common/CookiesSettingsModal/cookies_settings";
import Default from '@theme-views/public/layouts/Default';
import CookieDescription from "@views/common/CookieDescription";

export default {
  name: 'CookiePolicy',
  mixins: [cookies, cookies_settings],
  components: {
    Default, CookieDescription
  }
}
</script>

<style lang="scss">
.cookies-policy-page {
  .addres-image-con {
      max-width: 280px;
      padding-bottom: 20px;
  }
}
</style>
